/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListAgentPolicyGrantsRequest,
  ListAgentPolicyGrantsSecurity,
} from "../models/operations/listagentpolicygrants.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  AgentsListPolicyGrantsQueryData,
  buildAgentsListPolicyGrantsQuery,
  prefetchAgentsListPolicyGrants,
  queryKeyAgentsListPolicyGrants,
} from "./agentsListPolicyGrants.core.js";
export {
  type AgentsListPolicyGrantsQueryData,
  buildAgentsListPolicyGrantsQuery,
  prefetchAgentsListPolicyGrants,
  queryKeyAgentsListPolicyGrants,
};

export type AgentsListPolicyGrantsQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listPolicyGrants agents
 */
export function useAgentsListPolicyGrants(
  request: ListAgentPolicyGrantsRequest,
  security?: ListAgentPolicyGrantsSecurity | undefined,
  options?: QueryHookOptions<
    AgentsListPolicyGrantsQueryData,
    AgentsListPolicyGrantsQueryError
  >,
): UseQueryResult<
  AgentsListPolicyGrantsQueryData,
  AgentsListPolicyGrantsQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildAgentsListPolicyGrantsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listPolicyGrants agents
 */
export function useAgentsListPolicyGrantsSuspense(
  request: ListAgentPolicyGrantsRequest,
  security?: ListAgentPolicyGrantsSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    AgentsListPolicyGrantsQueryData,
    AgentsListPolicyGrantsQueryError
  >,
): UseSuspenseQueryResult<
  AgentsListPolicyGrantsQueryData,
  AgentsListPolicyGrantsQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildAgentsListPolicyGrantsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setAgentsListPolicyGrantsData(
  client: QueryClient,
  queryKeyBase: [
    parameters: { agentId: string; gramSession?: string | undefined },
  ],
  data: AgentsListPolicyGrantsQueryData,
): AgentsListPolicyGrantsQueryData | undefined {
  const key = queryKeyAgentsListPolicyGrants(...queryKeyBase);

  return client.setQueryData<AgentsListPolicyGrantsQueryData>(key, data);
}

export function invalidateAgentsListPolicyGrants(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { agentId: string; gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "agents", "listPolicyGrants", ...queryKeyBase],
  });
}

export function invalidateAllAgentsListPolicyGrants(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "agents", "listPolicyGrants"],
  });
}
